import React from 'react'
import PreviewModal from '../../components/PreviewModal'
import get from 'lodash/get'
import { PreviewProps, PreviewState } from './types'
import username from '../../lib/username'
import audit from '../../lib/audit/audit'

class Preview extends React.Component<PreviewProps, PreviewState> {

  state = {
    hasClickedEnter: false
  }

  componentDidMount () {

    const roomname = get(this.props.match, 'params.roomname', '')
    const search = get(this.props.location, 'search', '')
    if (!this.props.hasWebcastData) this.props.history.replace(`/${roomname}${search}`)

  }

  componentDidUpdate () {
    if (this.state.hasClickedEnter && this.props.hasSeat && this.props.hasRoom) this.enterPresenterScreen()

  }

  enterPresenterScreen () {

    const { roomname } = this.props
    const search = get(this.props, 'location.search', '')
    return this.props.history.replace(`/present/${roomname}${search}`)

  }

  handleEnterClick = () => {

    if (!this.props.username) return
    this.props.onEnterClick(username.getPureUsername(this.props.username))
    this.setState({ hasClickedEnter: true })

  }

  render () {

    return <PreviewModal
      isButtonDisabled={!this.props.hasDocs}
      onEnterClick={this.handleEnterClick}
    />

  }

}

export default Preview
